import { handleActions } from "redux-actions";
import { combineReducers } from "redux";
import {
  getTariffTypes,
  getTariffTypesSuccess,
  getTariffTypesFailure,
  getTariffFeePeriods,
  getTariffFeePeriodsSuccess,
  getTariffFeePeriodsFailure,
  getTariffPrices,
  getTariffPricesSuccess,
  getTariffPricesFailure,
  getTariffPrice,
  getTariffPriceSuccess,
  getTariffPriceFailure
} from "../actions/Tariff";

const tariff_types = handleActions(
  {
    [getTariffTypes]: (state, action) => {
      return { ...state, loading: true };
    },
    [getTariffTypesSuccess]: (state, action) => {
      const { payload } = action;
      return { ...state, loading: false, types: payload.data };
    },
    [getTariffTypesFailure]: (state, action) => {
      return state;
    }
  },
  {
    types: null,
    loading: false,
    error: ""
  }
);

const tariff_fee_periods = handleActions(
  {
    [getTariffFeePeriods]: (state, action) => {
      return { ...state, loading: true };
    },
    [getTariffFeePeriodsSuccess]: (state, action) => {
      const { payload } = action;
      return { ...state, loading: false, periods: payload.data };
    },
    [getTariffFeePeriodsFailure]: (state, action) => {
      return { ...state, loading: false };
    }
  },
  {
    periods: null,
    loading: false,
    error: ""
  }
);

const tariff_prices = handleActions(
  {
    [getTariffPrices]: (state, action) => {
      return { ...state, loading: true };
    },
    [getTariffPricesSuccess]: (state, action) => {
      const { payload } = action;
      return { ...state, loading: false, prices: payload.data };
    },
    [getTariffPricesFailure]: (state, action) => {},
    [getTariffPrice]: (state, action) => {
      return { ...state, loading: true };
    },
    [getTariffPriceSuccess]: (state, action) => {
      const { payload } = action;
      return { ...state, loading: false, price: payload.data };
    },
    [getTariffPriceFailure]: (state, action) => {}
  },
  {
    prices: null,
    price: null,
    loading: false,
    error: ""
  }
);

const tariff = combineReducers({
  tariff_types,
  tariff_fee_periods,
  tariff_prices
});

export { tariff };
